// src/admin/pages/CreateUser.jsx
import React, { useState, useEffect } from "react";
import { adminService } from "../../services/adminService";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import toast from "react-hot-toast";

const CreateUser = () => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    role_id: "",
  });
  const [loading, setLoading] = useState(false);

  // Load Roles
  useEffect(() => {
    async function loadRoles() {
      try {
        const data = await adminService.getRoles();
        setRoles(data);
      } catch (err) {
        console.error("Role load failed", err);
        toast.error("Failed to load roles");
      }
    }
    loadRoles();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await adminService.createUser(form);

      toast.success("User created successfully!", {
        style: { background: "#E8F8F8", color: "#042A2B" },
      });

      setTimeout(() => navigate("/admin/users"), 500);
    } catch (err) {
      console.error(err);
      toast.error("Failed to create user");
    }

    setLoading(false);
  };

  return (
    <div className="space-y-8">

      <h1 className="text-display">Create New User</h1>

      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-lg shadow stakeholder-summary-card p-8 grid grid-cols-1 md:grid-cols-2 gap-6"
      >
        {/* First Name */}
        <div className="flex flex-col gap-1">
          <label className="text-title">First Name</label>
          <input
            type="text"
            name="first_name"
            className="border rounded-md p-3 stakeholder-input"
            placeholder="Enter first name"
            value={form.first_name}
            onChange={handleChange}
          />
        </div>

        {/* Last Name */}
        <div className="flex flex-col gap-1">
          <label className="text-title">Last Name</label>
          <input
            type="text"
            name="last_name"
            className="border rounded-md p-3 stakeholder-input"
            placeholder="Enter last name"
            value={form.last_name}
            onChange={handleChange}
          />
        </div>

        {/* Email */}
        <div className="flex flex-col gap-1 md:col-span-2">
          <label className="text-title">Email</label>
          <input
            type="email"
            name="email"
            className="border rounded-md p-3 stakeholder-input"
            placeholder="Enter email"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        {/* Role */}
        <div className="flex flex-col gap-1 md:col-span-2">
          <label className="text-title">Role</label>
          <select
            name="role_id"
            className="border rounded-md p-3 stakeholder-dropdown"
            value={form.role_id}
            onChange={handleChange}
          >
            <option value="">Select Role</option>
            {roles.map((r) => (
              <option key={r.role_id} value={r.role_id}>
                {r.role}
              </option>
            ))}
          </select>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          className="col-span-1 md:col-span-2 bg-[#54B0AF] text-white py-3 rounded-md text-sm hover:opacity-90 transition flex items-center justify-center gap-2 shadow"
        >
          {loading && <Loader2 size={18} className="animate-spin" />}
          {loading ? "Creating..." : "Create User"}
        </button>
      </form>
    </div>
  );
};

export default CreateUser;
